import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERBODYDOWNLOADAPPSBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "app_store_link",
  "play_store_link"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterBodyDownloadAppsBlockDescriptor: _generatedBigFooterBodyDownloadAppsBlockDescriptor,
  bigFooterBodyDownloadAppsBlockBlocDefinition,
  bigFooterBodyDownloadAppsBlockDashboardLayout,
  bigFooterBodyDownloadAppsBlockConfig,
  bigFooterBodyDownloadAppsBlockResolveConfig,
  bigFooterBodyDownloadAppsBlockProperties,
} = doodBlockConfig(
  {
    name: "Big footer - Body - Download apps",
    componentType: 'BigFooterBodyDownloadAppsBlockComponent',
    category: 'footer',
    description: "Big footer - Body - Download apps.",
    keywords: [],
    allowedIn: [
      { bloc: "BigFooterBlockComponent", slot: "left_body" },
    ],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-download-apps.heading.label",
      }
    }),
    app_store_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-download-apps.app-store-link.label",
      }
    }),
    play_store_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-download-apps.play-store-link.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer-body-download-apps.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer-body-download-apps.fieldset.title.label",
            fields: ["heading"],
          },
          {
            legend: "pages.blocks.big-footer-body-download-apps.fieldset.links.label",
            fields: ["app_store_link", "play_store_link"],
          },
        ],
      },
    ],
  })
);

export function bigFooterBodyDownloadAppsBlockDescriptor(): IBlockDescriptor;
export function bigFooterBodyDownloadAppsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterBodyDownloadAppsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterBodyDownloadAppsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterBodyDownloadAppsBlockDescriptor, bigFooterBodyDownloadAppsBlockProperties, fieldOrder);
}

export {
  bigFooterBodyDownloadAppsBlockBlocDefinition,
  bigFooterBodyDownloadAppsBlockDashboardLayout,
  bigFooterBodyDownloadAppsBlockProperties,
  bigFooterBodyDownloadAppsBlockConfig,
  bigFooterBodyDownloadAppsBlockResolveConfig,
};

export type BigFooterBodyDownloadAppsBlockConfig = typeof bigFooterBodyDownloadAppsBlockConfig;
